import {useCreateUserMutation, useUpdateUserMutation, useUserQuery} from './useUsersQuery';
import {User} from '../types';

// One person. The record comes from users-api's getUser, keyed by username,
// never from scanning the list: the list is paged, so a person on a page not
// loaded yet is not in it (FNP-2015).
//
// Every write RETURNS its promise. The form and the drawer await it, so the
// drawer closes only on success and a failed save keeps the person's edits.
export const useUser = (username?: string) => {
    const query = useUserQuery(username ?? '');

    const createUserMutation = useCreateUserMutation();
    const updateUserMutation = useUpdateUserMutation();

    const createRecord = (values: User) => createUserMutation.mutateAsync(values);

    const updateRecord = (values: User) => {
        if (!query.data?.username) {
            return Promise.reject(new Error('username is required for update'));
        }
        return updateUserMutation.mutateAsync({username: query.data.username, record: values});
    };

    return {
        record: query.data,
        loading: query.isLoading,
        isError: query.isError,
        createRecord,
        updateRecord,
    };
};
